import { DISCOUNT_TYPE } from 'bundles/wes-common/hooks/useEnterpriseSelfServePriceV2';

/**
 * Use for contracts
 */
export const billingTypes = {
  ONE_TIME: 'ONE_TIME',
  QUARTERLY: 'QUARTERLY',
} as const;

export type BillingTypeValues = (typeof billingTypes)[keyof typeof billingTypes];

/** minm2Licenses experiment: treatment (minimum licenses in checkout / manage flows) */
export const MIN_LICENSE_COUNT_TEST = 2;
/** minm2Licenses experiment: control */
export const MIN_LICENSE_COUNT_CONTROL = 5;

export const MAX_LICENSE_COUNT = 125;

export const DEFAULT_LICENSE_COUNT = 10;

export const BILLING_TYPE_TO_DISPLAY_LABEL: Record<number, string> = {
  1: 'Annual',
  4: 'Quarterly',
};

export const BILLING_FREQUENCY_TO_BILLING_TYPE: Record<string, keyof typeof BILLING_TYPE_TO_DISPLAY_LABEL> = {
  ANNUALLY: 1,
  QUARTERLY: 4,
};

export const PROMOTION_TYPE_TO_DISPLAY_LABEL_DEFAULT: Record<
  (typeof DISCOUNT_TYPE)[keyof typeof DISCOUNT_TYPE],
  string
> = {
  [DISCOUNT_TYPE.Promotion]: 'Promotion',
  [DISCOUNT_TYPE.VolumeDiscount]: 'Volume discount',
};

export const PROMOTION_TYPE_TO_DISPLAY_LABEL_RENEWAL: Record<
  (typeof DISCOUNT_TYPE)[keyof typeof DISCOUNT_TYPE],
  string
> = {
  [DISCOUNT_TYPE.Promotion]: 'Renewal offer',
  [DISCOUNT_TYPE.VolumeDiscount]: 'Volume discount at renewal',
};

export { DISCOUNT_TYPE };
